import { WebhookDoc } from '@upflowy/types';

import { StateEvent } from '../types';

const findApplicableHook = (stepId: string, webhooks: WebhookDoc[], event: StateEvent) =>
  webhooks.find((wh) => {
    if (wh.action !== event.type) return false;
    switch (wh.target) {
      case 'step':
        return wh.stepId === stepId;
      case 'trigger':
        return wh.triggerId === event.meta?.triggerId;
      default:
        return false;
    }
  });

export default findApplicableHook;
